<template>
  <div>
    <div class="row flex-center" style="height: 0.417rem">
      <span class="row" v-if="showRealNumber"
        >{{ showPhoneNumber }} <slot name="suffix"></slot>
      </span>
      <span class="row" v-else
        >{{ phoneNumber }} <slot name="suffix"></slot>
      </span>

      <div v-if="showPowerCodeBtn" class="seeicon ml4" @click="decrypt">
        <span
          class="iconfont icon-yulan P-Cursor"
          v-if="showRealNumber"
          :style="{ 'font-size': fontsize + 'rem' }"
        ></span>

        <span
          class="iconfont icon-a-CloseSee P-Cursor"
          v-else
          :style="{ 'font-size': fontsize + 'rem' }"
        >
        </span>

        <!-- <img v-if="showRealNumber" 
          :style="{ width: dynamicWidth + 'px', height: dynamicHeight + 'px' }" 
          class="see-img" :src="icon_see" />
          <img v-else class="hide-img" 
          :style="{ width: dynamicWidth + 'px', height: dynamicHeight + 'px' }" 
          :src="icon_hide" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import crypto from "@/util/crypto.js";
import { lookPatientPhone } from "@/api/base.js";

export default {
  name: "hideMobile",
  props: {
    fontsize: {
      type: Number,
      default: 0.292,
    },
    showPowerCodeBtn: {
      type: Boolean,
      default: true,
    },
    phoneNumber: {
      type: String,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
    patientId: {
      type: String,
      required: false,
    },
    directDecrypt: {
      type: Boolean,
      default: false,
    },
    place: {
      type: String,
      default: "12",
    },
  },
  components: {},
  data() {
    return {
      showRealNumber: false, // 是否显示真实手机号码
      showPhoneNumber: "", // 被隐藏的手机号码
      sendmsg: false,
    };
  },
  setup() {},
  mounted() {},
  methods: {
    decrypt() {
      let that = this;

      // 点击查看按钮时，切换显示真实手机号码
      let togglePhoneNumberDisplay = function () {
        that.showRealNumber = !that.showRealNumber;
        that.$emit("phoneNumberDisplayHide", {
          value: that.showRealNumber,
        });
      };

      if (that.sendmsg) {
        togglePhoneNumberDisplay();
        return;
      }

      if (that.directDecrypt) {
        that.showPhoneNumber = crypto.phonedecryptDES(that.code);
        togglePhoneNumberDisplay();
        that.sendmsg = true;
        return;
      }

      lookPatientPhone({
        patientIds: [that.patientId],
        place: that.place,
      }).then((res) => {
        let { data } = res.data;

        if (data) {
          //查看过了
          that.showPhoneNumber = crypto.phonedecryptDES(that.code);
          togglePhoneNumberDisplay();
          that.sendmsg = true;
        }
      });
    },
  },
};
</script>

<style scoped>
/* 样式 */
</style>
